import type { Coupon, CouponId } from '../../../../../schema/coupon/entry.js';
import type { CouponState } from '../../../../domain/entry.js';

/**
 * Selects coupon collection from state.
 *
 * @param couponId Coupon id to select
 * @returns Coupon entity
 */
export function selectCoupons(couponId: CouponId) {
  return (state: CouponState): Coupon[] | undefined => {
    return state.Coupons[couponId];
  };
}
